import { render, staticRenderFns } from "./ShoppingGuide.vue?vue&type=template&id=4e3d2f12&scoped=true"
import script from "./ShoppingGuide.vue?vue&type=script&lang=js"
export * from "./ShoppingGuide.vue?vue&type=script&lang=js"
import style0 from "./ShoppingGuide.vue?vue&type=style&index=0&id=4e3d2f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3d2f12",
  null
  
)

export default component.exports